import { render, staticRenderFns } from "./PendingPackages.vue?vue&type=template&id=6aa9ef4c&scoped=true"
import script from "./PendingPackages.vue?vue&type=script&lang=js"
export * from "./PendingPackages.vue?vue&type=script&lang=js"
import style0 from "./PendingPackages.vue?vue&type=style&index=0&id=6aa9ef4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa9ef4c",
  null
  
)

export default component.exports